export const cookies = new Map(
	document.cookie.split("; ").map((c) => {
		const parts = c.split("=")
		const name = parts.shift()
		const value = parts.join("=")
		return [name, value]
	})
)
